"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function trackImpression(dataLayer, product, currency, collection) {
    dataLayer.push({
        event: "impressionsPushed",
        ecommerce: {
            actionField: { list: collection },
            currencyCode: currency,
            impressions: product
        }
    });
}
exports.trackImpression = trackImpression;
function trackProductClick(dataLayer, product, currency, list) {
    dataLayer.push({
        event: "productClick",
        ecommerce: {
            currencyCode: currency,
            click: {
                actionField: { list: list },
                products: [product]
            }
        }
    });
}
exports.trackProductClick = trackProductClick;
function trackSignUp(dataLayer) {
    dataLayer.push({
        event: "signUp",
        eventCategory: "Sign Up",
        eventAction: "Create Account",
        userId: ""
    });
}
exports.trackSignUp = trackSignUp;
